export const GForms = () => {
    return {
        init() {
            jQuery(document).on("gform_confirmation_loaded", this.handleFormSubmission);
        },
        handleFormSubmission() {
            const screenHeight = jQuery(window).height();
            const gfAnchor = jQuery('.gform_anchor');

            if (!gfAnchor.length) return;

            jQuery('html, body').animate({
                scrollTop: gfAnchor.offset().top - screenHeight / 2 + gfAnchor.height() / 2
            }, 300);
        }
    }
}